<article class="technical-alerts">
	@for (item of technicalAlerts$ | async; track item) {
		<div
			class="technical-alerts__item"
			[ngClass]="{ 'technical-alerts__item--hide': item.hideBlock }"
		>
			<div
				class="technical-alerts__item-text"
				[innerHTML]="item.text"
			></div>
			<button
				class="button-reset close technical-alerts__item-close"
				tabindex="20"
				type="button"
				(click)="item.hideBlock = true"
			></button>
		</div>
	}
</article>
